import { useEffect } from 'react';

export const useInterval = (
  interval: number,
  cb: () => void,
  isEnabled = true,
) => {
  useEffect(() => {
    if (isEnabled) {
      const intervalInstance = setInterval(cb,
        interval);

      return () => {
        clearInterval(intervalInstance);
      };
    }
  },
  [cb, interval, isEnabled]);
};
